import { useEffect, useState } from "react";

import {
  date2String,
  string2Datetime,
  useDidMountEffect,
} from "../../utils/utils";
import {
  getBatterySoCFlow,
  getConsumptionFlow,
  getPowerFlow,
  getProductionFlow,
} from "../../utils/flowhistoryutils";

export default function useHourlyFlow(locationClient, isFocused = true) {
  const [date, setDate] = useState(new Date());
  const [flowHistory, setFlowHistory] = useState(null);

  const getFlow = async (date) =>
    locationClient.getHourlyFlow({ date: date2String(date), sync: false });
  const syncFlow = async (date) =>
    locationClient.getHourlyFlow({ date: date2String(date), sync: true });

  const loadData = async () => {
    const response = await getFlow(date);
    setFlowHistory(response.data);
    const cDate = date;
    const syncResponse = await syncFlow(date);
    if (date === cDate) setFlowHistory(syncResponse.data);
  };

  const clearData = () => {
    setFlowHistory(null);
  };

  const initData = () => {
    const today = new Date();
    if (date !== today) setDate(today);
    else loadData();
  };

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  useDidMountEffect(() => {
    setFlowHistory(null);
    loadData();
  }, [date]);

  const time = flowHistory && flowHistory.time.map((t) => string2Datetime(t));
  const powerFlow = flowHistory && getPowerFlow(flowHistory);
  const productionFlow = flowHistory && getProductionFlow(flowHistory);
  const consumptionFlow = flowHistory && getConsumptionFlow(flowHistory);
  const batterySoCFlow = flowHistory && getBatterySoCFlow(flowHistory);

  return {
    date: { value: date, setValue: setDate },
    flowHistory,
    time,
    flow: {
      power: powerFlow,
      production: productionFlow,
      consumption: consumptionFlow,
      batterySoc: batterySoCFlow,
    },
    data: { init: initData, update: loadData, clear: clearData },
  };
}
